const resetSelectedInfo = (state, action) => {
    const vehicleInfoData = action.payload.vehicleInfo;
    if (!vehicleInfoData.Types || vehicleInfoData.Types.length <= 0) {
        return new Map();
    }
    return state;
};
export default resetSelectedInfo;
//# sourceMappingURL=resetSelectedInfo.js.map